import axios from 'axios'

const getAll = async () => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/festival`)
  return data
}

const get = async (id) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/festival/${id}`)
  return data
}

const create = async (
  name,
  description,
  dateEnd,
  events,
  image,
  url
) => {
  const formData = new FormData()
  formData.append('name', name)
  formData.append('description', description)
  if (dateEnd) formData.append('dateEnd', dateEnd)
  formData.append('events', JSON.stringify(events))
  formData.append('url', url)
  if (image) formData.append('image1', image)
  const { data } = await axios.post(`${process.env.VUE_APP_API}/festival`, formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  )
  return data
}

const update = async (
  id,
  name,
  description,
  dateEnd,
  image,
  events,
  url
) => {
  const formData = new FormData()
  formData.append('name', name)
  formData.append('description', description)
  if (dateEnd) formData.append('dateEnd', dateEnd)
  formData.append('events', JSON.stringify(events))
  formData.append('url', url)
  if (image) formData.append('image1', image)
  const { data } = await axios.put(`${process.env.VUE_APP_API}/festival/${id}`, formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  )
  return data
}

const remove = async (id) => {
  const { data } = await axios.delete(`${process.env.VUE_APP_API}/festival/${id}`)
  return data
}

export {
  getAll,
  get,
  create,
  update,
  remove
}
